import React from "react";
import { useTranslation } from "react-i18next";
import {useQuery} from "../utils/router"
import News from "./News"
import Blogs from "./Blogs"
import Books from "./Books"
import Podcasts from "./Podcasts"
import Videos from "./Videos"
import {KEYWORDS_URL_QUERY_PARAMETER, RESOURCE_URL_QUERY_PARAMETER, PUBLISHED_AT_DATETIME_FILTER_URL_QUERY_PARAMETER, DURATION_FILTER_URL_QUERY_PARAMETER, SORT_BY_FILTER_URL_QUERY_PARAMETER, INPUT_FORM_SUBMIT_ACTION} from '../constants/Query'

export default function SearchResults() {
    const { t } = useTranslation();
    let query = useQuery();
    const keywords = query.get(KEYWORDS_URL_QUERY_PARAMETER);
    // `let`, not `const`: the line below REASSIGNS this, and with a `const` that
    // threw a TypeError in strict mode -- so any unrecognised ?ia= value crashed
    // the results page instead of falling back.
    let resource = query.get(RESOURCE_URL_QUERY_PARAMETER) || "news";
    if (!['news', 'podcasts', 'blogs', 'books', 'videos'].includes(resource)) {
        resource = 'news';
    }
    const currentPage = Math.max(parseInt(query.get('p') || 1), 1);
    const timeFilter = query.get(PUBLISHED_AT_DATETIME_FILTER_URL_QUERY_PARAMETER) || "";
    const durationFilter = query.get(DURATION_FILTER_URL_QUERY_PARAMETER) || "";
    const sortByFilter = query.get(SORT_BY_FILTER_URL_QUERY_PARAMETER) || "";

    const urlPrefix = `${INPUT_FORM_SUBMIT_ACTION}?${KEYWORDS_URL_QUERY_PARAMETER}=${keywords}&${RESOURCE_URL_QUERY_PARAMETER}=${resource}`

    React.useEffect(() => {
        document.title = t('search.title', { resource_title: t(`resources.${resource}.title`) })
        const tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        tag.setAttribute('content', t('search.desc', { resource_name: t(`resources.${resource}.name`) }));
        document.head.appendChild(tag);
    }, []);

    if (resource === 'news') {
        return (
            <News resource={resource} keywords={keywords} currentPage={currentPage} urlPrefix={urlPrefix} timeFilter={timeFilter} sortByFilter={sortByFilter}/>
        );
    } else if (resource === 'blogs') {
        return (
            <Blogs resource={resource} keywords={keywords} currentPage={currentPage} urlPrefix={urlPrefix} timeFilter={timeFilter} sortByFilter={sortByFilter}/>
        );
    } else if (resource === 'videos') {
        return (
            <Videos resource={resource} keywords={keywords} currentPage={currentPage} urlPrefix={urlPrefix} timeFilter={timeFilter} durationFilter={durationFilter} sortByFilter={sortByFilter}/>
        );
    } else if (resource === 'books') {
        return (
            <Books resource={resource} keywords={keywords} currentPage={currentPage} urlPrefix={urlPrefix} timeFilter={timeFilter} sortByFilter={sortByFilter}/>
        );
    } else if (resource === 'podcasts') {
        return (
            <Podcasts resource={resource} keywords={keywords} currentPage={currentPage} urlPrefix={urlPrefix} timeFilter={timeFilter} durationFilter={durationFilter} sortByFilter={sortByFilter}/>
        );
    } else {
        return null
    }
}
